'use client';

import { c as _c } from "react/compiler-runtime";
import { Box, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Typography, styled } from '@mui/material';
import type { ParameterCheckResult } from '@repo/api-gw-sdk';
const ParameterCell = styled(TableCell)(() => ({
  borderBottom: '1px solid var(--mui-palette-divider)',
  paddingTop: '12px',
  paddingBottom: '12px',
  paddingLeft: 0,
  paddingRight: '24px',
  '&:last-child': {
    paddingRight: 0
  }
}));
const ParameterHeaderCell = styled(ParameterCell)(() => ({
  paddingTop: 0
}));
const RequiredValueCell = t0 => {
  const $ = _c(3);
  const {
    param
  } = t0;
  if (param.unmeasured) {
    let t1;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
      t1 = <Typography variant="body1">N/A - run the verification of step 2 first</Typography>;
      $[0] = t1;
    } else {
      t1 = $[0];
    }
    return t1;
  }
  const t1 = param.isMinimum ? `\u2265${param.requiredValue}` : param.requiredValue;
  let t2;
  if ($[1] !== t1) {
    t2 = <Typography variant="body1"><code>{t1}</code></Typography>;
    $[1] = t1;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  return t2;
};
const StatusIcon = t0 => {
  const $ = _c(6);
  const {
    param
  } = t0;
  if (param.unmeasured) {
    let t1;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
      t1 = <Box component="i" className="material-symbols-schedule-outline text-[18px]" sx={{
        color: "var(--mui-palette-custom-GREY-01)"
      }} />;
      $[0] = t1;
    } else {
      t1 = $[0];
    }
    return t1;
  }
  const t1 = param.ok ? "material-symbols-check-circle-outline-rounded text-[18px]" : "material-symbols-cancel-outline text-[18px]";
  const t2 = param.ok ? "var(--mui-palette-success-main)" : "var(--mui-palette-error-main)";
  let t3;
  if ($[1] !== t2) {
    t3 = {
      color: t2
    };
    $[1] = t2;
    $[2] = t3;
  } else {
    t3 = $[2];
  }
  let t4;
  if ($[3] !== t1 || $[4] !== t3) {
    t4 = <Box component="i" className={t1} sx={t3} />;
    $[3] = t1;
    $[4] = t3;
    $[5] = t4;
  } else {
    t4 = $[5];
  }
  return t4;
};
const ParameterTableRow = t0 => {
  const $ = _c(13);
  const {
    param
  } = t0;
  let t1;
  if ($[0] !== param.parameterName) {
    t1 = <ParameterCell><Typography variant="body1"><code>{param.parameterName}</code></Typography></ParameterCell>;
    $[0] = param.parameterName;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const t2 = param.currentValue || "Not set";
  let t3;
  if ($[2] !== t2) {
    t3 = <ParameterCell><Typography variant="body1"><code>{t2}</code></Typography></ParameterCell>;
    $[2] = t2;
    $[3] = t3;
  } else {
    t3 = $[3];
  }
  let t4;
  if ($[4] !== param) {
    t4 = <ParameterCell><RequiredValueCell param={param} /></ParameterCell>;
    $[4] = param;
    $[5] = t4;
  } else {
    t4 = $[5];
  }
  let t5;
  if ($[6] !== param) {
    t5 = <ParameterCell><StatusIcon param={param} /></ParameterCell>;
    $[6] = param;
    $[7] = t5;
  } else {
    t5 = $[7];
  }
  let t6;
  if ($[8] !== t1 || $[9] !== t3 || $[10] !== t4 || $[11] !== t5) {
    t6 = <TableRow>{t1}{t3}{t4}{t5}</TableRow>;
    $[8] = t1;
    $[9] = t3;
    $[10] = t4;
    $[11] = t5;
    $[12] = t6;
  } else {
    t6 = $[12];
  }
  return t6;
};
export const ParameterTable = t0 => {
  const $ = _c(8);
  const {
    params
  } = t0;
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = <ParameterHeaderCell><Typography variant="subtitle2">Parameter</Typography></ParameterHeaderCell>;
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  let t2;
  if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = <ParameterHeaderCell><Typography variant="subtitle2">Current value</Typography></ParameterHeaderCell>;
    $[1] = t2;
  } else {
    t2 = $[1];
  }
  let t3;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = <ParameterHeaderCell><Typography variant="subtitle2">Required value</Typography></ParameterHeaderCell>;
    $[2] = t3;
  } else {
    t3 = $[2];
  }
  let t4;
  if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
    t4 = <TableHead><TableRow>{t1}{t2}{t3}<ParameterHeaderCell><Typography variant="subtitle2">Status</Typography></ParameterHeaderCell></TableRow></TableHead>;
    $[3] = t4;
  } else {
    t4 = $[3];
  }
  let t5;
  if ($[4] !== params) {
    t5 = params.map(_temp);
    $[4] = params;
    $[5] = t5;
  } else {
    t5 = $[5];
  }
  let t6;
  if ($[6] !== t5) {
    t6 = <TableContainer><Table size="small">{t4}<TableBody>{t5}</TableBody></Table></TableContainer>;
    $[6] = t5;
    $[7] = t6;
  } else {
    t6 = $[7];
  }
  return t6;
};
function _temp(param) {
  return <ParameterTableRow key={param.parameterName} param={param} />;
}